import { AuthContext } from 'context';
import { DICTONARY } from 'const/Dictonary';
import { Formik } from 'formik';
import { Link as RouterLink } from 'react-router-dom';
import { LoginForm, LoginFormContainer } from '../menu/LoginForm';
import { RUTAS } from 'const/Rutas';
import { SchemaLogin } from '../schema/ScemaLogin';
import { useContext } from 'react';
import ButtonComponent from 'components/design-system/Button/Button';
import MiCuenta from '../menu/MiCuenta';
import authenticationService from 'services/authentication';

export const MenuLogin = ({ forceRefresh, history, match }) => {
  const { login, logged, logout } = useContext(AuthContext);

  if (logged) {
    return (
      <MiCuenta
        handleLogout={logout}
        forceRefresh={forceRefresh}
        history={history}
        match={match}
      />
    );
  }

  const handleIngresar = async values => {
    if (!values.email || !values.password) return;

    await authenticationService
      .iniciarSesion(
        {
          correoElectronico: (values.email + '').trim(),
          password: values.password
        },
        DICTONARY.INTERCEPTOR.ACTIVADO
      )
      .then(response => {
        if (response.data) {
          login(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <div className="loginMenu d-hidden flex">
      <LoginFormContainer>
        <Formik
          initialValues={{
            email: '',
            password: ''
          }}
          validationSchema={SchemaLogin}
          onSubmit={async (values, { setSubmitting }) => {
            await handleIngresar(values);
            setSubmitting(false);
          }}
        >
          {({ values, errors, handleChange, handleReset, setFieldValue }) => (
            <LoginForm
              values={values}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              handleReset={handleReset}
              errors={errors}
            />
          )}
        </Formik>
      </LoginFormContainer>
      <RouterLink to={RUTAS.REGISTRARSE}>
        <ButtonComponent
          type="ghost"
          aria-controls="simple-menu"
          aria-haspopup="true"
          className="text-white hover:text-uv-primary-0 !px-2 sm:!px-4 !text-xs sm:text-sm"
        >
          Registrarse
        </ButtonComponent>
      </RouterLink>
    </div>
  );
};
